import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import ExteriorView from '../../containers/exterior-view';
import ExteriorViewAccessories from '../../containers/exterior-view-accessories';

const ExteriorViewBlock = props => <ExteriorView {...props} />;
ExteriorViewBlock.displayName = 'ExteriorView';

export default withDynamicComponents({
  componentWhitelist: [
    ExteriorViewAccessories,
  ],
  mapInputToOutput: [
    ['accessories', 'accessories'],
  ],
})(ExteriorViewBlock);



// WEBPACK FOOTER //
// ./src/blocks/exterior-view/index.jsx